<template>
    <ul class="header-menu">
      <li
          :class="visibilityProps? '' : 'visibility_hidden'"
          class="pointer"
      >
        <a @click="$modal.show('schedule-calendar-modal')">
          <img
              src="/images/ic/header/ic-calendar.svg"
              alt=""
          />
          <span class="txt_caption_1 --grey80 line-break-no">{{this.$t('RMC.schedule')}}</span>
        </a>
      </li>
      <span v-show="visibilityProps">|</span>
      <li
          :class="visibilityProps? '' : 'visibility_hidden'"
          class="pointer"
      >
        <router-link to="/appointments">
          <img
              class="menu"
              :class="path === '' || path === 'appointments' ? 'click' : ''"
              src="/images/ic/header/ic-stethoscope.svg"
              alt=""
          >
          <span class="txt_caption_1 --grey80 line-break-no">{{this.$t('appointment.appointments')}}</span>
        </router-link>
      </li>
      <li :class="visibilityProps? '' : 'visibility_hidden'">
        <router-link to="/patientList">
          <img
              class="menu"
              :class="path === 'patientList' ? 'click' : ''"
              src="/images/ic/header/ic-group.svg"
              alt=""
          >
          <span class="txt_caption_1 --grey80 line-break-no">{{this.$t('menu.patient_list')}}</span>
        </router-link>
      </li>
      <li :class="visibilityProps? '' : 'visibility_hidden'">
        <router-link to="/rehab">
          <img
              class="menu"
              :class="path === 'rehab' ? 'click' : ''"
              src="/images/ic/header/ic-exercise.svg"
              alt=""
          >
          <span class="txt_caption_1 --grey80 line-break-no">{{this.$t('menu.rehabilitation')}}</span>
        </router-link>
      </li>
      <li :class="visibilityProps? '' : 'visibility_hidden'">
        <router-link to="/options">
          <img
              class="menu"
              :class="path === 'options' ? 'click' : ''"
              src="/images/ic/header/ic-person.svg"
              alt=""
          >
          <span class="txt_caption_1 --grey80 line-break-no">{{this.$t('menu.my_page')}}</span>
        </router-link>
      </li>
      <span v-show="visibilityProps">|</span>
      <li
          :class="visibilityProps? '' : 'visibility_hidden'"
          class="pointer"
      >
        <a @click="$modal.toggle('notification-modal')">
          <img v-if="readProps === false" :src="changeNotificationImages.on" alt="">
          <img v-else :src="changeNotificationImages.off" alt="">
          <span class="txt_caption_1 --grey80">{{this.$t('notice.name')}}</span>
        </a>
      </li>
      <li class="pointer">
        <a @click="$modal.show('yes-or-no-modal', {questionType:'logOut', function: clickLogOut})">
          <img
              src="/images/ic/header/ic-logout.svg"
              alt=""
          >
          <span class="txt_caption_1 --grey80 line-break-no">{{this.$t('account.logout')}}</span>
        </a>
      </li>
    </ul>
</template>
<script>
import _API from "../../api";
import {mapActions} from "vuex";

export default {
  name: 'MenuList',
  props: {
    visibilityProps: Boolean,
    readProps: Boolean
  },
  data() {
    return {
      changeNotificationImages: {
        on: '/images/ic/header/ic-notification-on.svg',
        off: '/images/ic/header/ic-notification-off.svg'
      },
      path: '',
    }
  },
  methods: {
    ...mapActions(['logOut']),
    clickLogOut() {
      if (this.$fbConf.isSupported)
        this.updateFcmToken();

      localStorage.setItem('refreshToken', '');
      localStorage.setItem('accessToken', '');

      this.logOut();
      this.$router.push('/login');
    },
    updateFcmToken() {
      _API.USER.updateFcmToken('')
          .then(({data}) => {
            if (data.isSuccess) {
              localStorage.setItem('fcmToken', '');
              this.$fbConf.REMOVE_ALL_NOTI_ITEMS_FROM_DB();
            }
          })
    },
  },
  updated() {
    this.$nextTick(function () {
      this.path = window.location.pathname.slice(1).split('/')[0];
    })
  },
  watch: {
    $route: {
      deep: true,
      handler(newVal) {
        this.path = newVal.path.slice(1).split('/')[0];
      }
    }
  },
}
</script>
<style lang="scss">
.header-menu {
  li {
    .menu {
      filter: opacity(0.3);
    }

    .click {
      filter: opacity(1);
    }

    .menu:hover {
      filter: opacity(1);
    }
  }
}
</style>